<template>
    <span class="flex mx-1 my-1 inline-block">
        <div
            :class="[
                canDelete ? 'rounded-l' : 'rounded',
                'flex items-center bg-blue-600 text-white',
                isLarge ? 'px-2 py-1 md:px-3 md:py-3' : 'px-2 py-1'
            ]"
        >
            <span class="slot leading-none">
                <slot />
            </span>
        </div>
        <button
            v-if="canDelete"
            class="flex items-center rounded-r bg-blue-400 px-1"
            role="button"
            :aria-label="ariaCloseLabel"
            :disabled="disabled"
            @click="close()"
            @keyup.delete.prevent="close()"
        >
            <m-icon size="13" stroke="2" name="x-circle" color="white"></m-icon>
        </button>
    </span>
</template>

<script>
import MIcon from "../components/icons/icon.vue";

export default {
    name: "MTag",
    components: {
        MIcon
    },
    props: {
        canDelete: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: true
        },
        ariaCloseLabel: {
            type: String,
            default: ""
        },
        isLarge: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        close() {
            if (this.disabled) return;
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.slot {
    padding-bottom: 3px;
}
</style>
